import React, { useContext } from 'react';
import clsx from 'clsx';
import { langLabels, languages } from '../virtual-assistant.constants';
import { PartContext } from '/react4xp/parts/virtual-assistant/virtual-assistant';
import { Languages } from '../../knowledge-base-common/knowledge-base-common.type';

const LanguageSelector = () => {
    const { language: activeLanguage } = useContext(PartContext);

    const handleChangeLanguage = (language: Languages) => {
        if (language !== activeLanguage) {
            const urlArr = window.location.href.split('/');
            window.location.href = urlArr.slice(0, 3).join('/') + '/' + language + '/' + urlArr.slice(4).join('/');
        }
    };

    return (
        <div className="languages-container">
            {languages.map((language) => (
                <button
                    key={language}
                    className={clsx({
                        'language-button': true,
                        'language-button_active': language === activeLanguage,
                    })}
                    onClick={() => handleChangeLanguage(language)}
                >
                    {langLabels[language]}
                </button>
            ))}
        </div>
    );
};

export default LanguageSelector;
